(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('mediaList', MediaListDirective)

    /** @ngInject */
    function MediaListDirective(PATHS) {
        function MediaListDirectiveController(HelperService) {
            const vm = this;

            let isPreviousInformative = false;

            vm.getMediaImage = media => {
                return HelperService.imageResizePath('news', media.Id, media.Image, 100, 100);
            }

            vm.getMediaLink = media => {
                let mediaUrl = '';

                if (isPreviousInformative)
                    mediaUrl = `/media/${media.NewsCategory.Url}/${media.Url}?NewsId=${vm.newsId}&NewsTitle=${vm.newsTitle}`
                else
                    mediaUrl = `/media/${media.NewsCategory.Url}/${media.Url}`;

                return mediaUrl;
            }

            vm.init = () => {
                if (vm.newsId && vm.newsTitle)
                    isPreviousInformative = true;
            }
        }

        function link(scope, attrs, elem, ctrl) {
            ctrl.init();
        }

        return {
            bindToController: true,
            controller: MediaListDirectiveController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/media-list/media-list.html`,
            link: link,
            scope: {
                medias: '=',
                newsId: '=',
                newsTitle: '='
            }
        }
    }
}());